export default "__VITE_ASSET__CVXvS2Bg__"